import React from 'react';
// @ts-ignore
import saga from '../../../assets/pictures/projects/software/saga.mp4';
// @ts-ignore
import computer from '../../../assets/pictures/projects/software/computer.mp4';
// @ts-ignore
import scroll from '../../../assets/pictures/projects/software/scroll.mp4';
import ResumeDownload from '../ResumeDownload';
import VideoAsset from '../../general/VideoAsset';


export interface SoftwareProjectsProps {}

const projectTexts = {
    seumei: {
        title: "SeuMei",
        description: `
            SeuMei é um sistema inteligente de gestão de sites e projetos que integra diversas funcionalidades em um único ambiente.
            Com uma abordagem modular, permite que empresas e indivíduos criem, gerenciem e otimizem seus projetos digitais de forma
            eficiente. O sistema é projetado para ser escalável, com capacidades de adaptação a diferentes indústrias e necessidades
            de negócio. 
        `,
    },
    homecam: {
        title: "HomeCam",
        description: `
            O HomeCam é um sistema de segurança interno que utiliza câmeras de vigilância operadas por modelos de machine learning.
            Ele permite que o monitoramento seja realizado localmente, garantindo privacidade e segurança dos dados. Através de 
            algoritmos avançados, o HomeCam pode identificar e alertar sobre atividades suspeitas, oferecendo uma camada extra de
            proteção para residências e empresas.
        `,
    },
    willdash: {
        title: "WillDash",
        description: `
            WillDash é um aplicativo inovador focado em transformar a perda de calorias em recompensas financeiras. 
            Com uma interface amigável, ele rastreia atividades físicas, calcula calorias queimadas e converte esses dados 
            em benefícios monetários. O WillDash incentiva uma vida saudável ao permitir que os usuários ganhem enquanto perdem peso, 
            promovendo uma abordagem divertida e recompensadora para o fitness.
        `,
    },
    sprintdev: {
        title: "SprintDev",
        description: `
            SprintDev é uma metodologia e sistema completo para gerenciar, organizar, precificar e quantificar sprints de forma justa, saudável e democrática. 
            Oferece ferramentas para planejamento detalhado, estimativas precisas e acompanhamento em tempo real dos sprints, 
            garantindo uma gestão eficiente do ciclo de desenvolvimento. O sistema é multilíngue e adaptável a diversas equipes de desenvolvimento, 
            proporcionando uma solução robusta para a organização de projetos ágeis.
        `,
    },
    facesense: {
        title: "FaceSense",
        description: `
            FaceSense é uma PoC (Proof of Concept) desenvolvida para auxiliar cirurgias faciais com o uso de inteligência artificial.
            Utilizando segmentações com machine learning, o sistema oferece uma análise detalhada e em tempo real das áreas cirúrgicas,
            proporcionando maior precisão e segurança durante o procedimento. O FaceSense tem o potencial de revolucionar a forma como 
            as cirurgias faciais são planejadas e executadas.
        `,
    },
    libratranslator: {
        title: "LibraTranslator",
        description: `
            LibraTranslator é um aplicativo inovador focado na tradução de língua de sinais (LIBRAS) para diversos idiomas. 
            Alimentado pela comunidade e por tarefas autônomas, o aplicativo utiliza inteligência artificial para melhorar continuamente a acurácia das traduções, 
            permitindo que pessoas ao redor do mundo se comuniquem sem barreiras linguísticas. O LibraTranslator também serve como uma plataforma educacional, 
            promovendo a inclusão e a acessibilidade para surdos e ouvintes.
        `,
    },
    franquiasistem: {
        title: "FranquiaSistem",
        description: `
            FranquiaSistem é um sistema SaaS para franquias, projetado para ser um extensor do SeuMei e facilmente integrável a outros sistemas que desejam adotar um modelo de franquia. 
            Com recursos adaptativos, o sistema permite a gestão centralizada de múltiplas franquias, oferecendo ferramentas para controle de operações, marketing, e finanças. 
            Exemplos diretos de integração incluem WilLDash, FaceSense e Ambient3D, demonstrando sua versatilidade e poder de adaptação a diferentes indústrias.
        `,
    },
    meumaterial: {
        title: "MeuMaterial / MinhaConstrução",
        description: `
            MeuMaterial é uma extensão do SeuMei voltada para o setor de materiais de construção. O sistema oferece um serviço SaaS direto para o usuário, 
            que inclui desde o fornecimento de materiais até a contratação de mão de obra especializada e aluguel de equipamentos. 
            Integrado em uma única plataforma, o MeuMaterial simplifica a gestão de obras e reformas, atendendo tanto clientes finais quanto profissionais do setor.
        `,
    },
    matriz: {
        title: "Matriz",
        description: `
            Matriz é um holding de investimentos e empresas derivadas, que abrange desenvolvimento de software, marketing, audiovisual, 
            sistemas SaaS, aplicativos PWA, e mais. A Matriz atua como um núcleo estratégico que impulsiona o crescimento e a inovação em diversos setores, 
            oferecendo soluções tecnológicas avançadas e serviços personalizados para cada negócio. Com uma abordagem centrada em inovação, 
            a Matriz se destaca por sua capacidade de integrar múltiplas áreas em um ecossistema coeso e eficiente.
        `,
    },
};

const SoftwareProjects: React.FC<SoftwareProjectsProps> = (props) => {
    return (
        <div className="site-page-content">
            <h1>Softwares</h1>
            <h3>Projetos</h3>
            <br />
            <p>
                Abaixo estão alguns dos principais projetos, POCs, e startups desenvolvidos recentemente.
            </p>
            <br />
            <ResumeDownload />
            <br />
            <div className="text-block">
                <h2>{projectTexts.seumei.title}</h2>
                <br />
                <p>{projectTexts.seumei.description}</p>
            </div>
            <div className="text-block">
                <h2>{projectTexts.facesense.title}</h2>
                <p>
                    {projectTexts.facesense.description}
                </p>
            </div>
            <div className="text-block">
                <h2>{projectTexts.willdash.title}</h2>
                <p>
                    {projectTexts.willdash.description}
                </p>
            </div>
            <div className="text-block">
                <h2>{projectTexts.sprintdev.title}</h2>
                <p>
                    {projectTexts.sprintdev.description}
                </p>
            </div>
            <div className="text-block">
                <h2>{projectTexts.matriz.title}</h2>
                <p>
                    {projectTexts.matriz.description}
                </p>
            </div>
            <div className="text-block">
                <h2>{projectTexts.franquiasistem.title}</h2>
                <p>
                    {projectTexts.franquiasistem.title}
                </p>
            </div>
            <div className="text-block">
                <h2>{projectTexts.homecam.title}</h2>
                <p>
                    {projectTexts.homecam.description}
                </p>
            </div>
            <div className="text-block">
                <h2>{projectTexts.libratranslator.title}</h2>
                <p>
                    {projectTexts.libratranslator.description}
                </p>
            </div>
            <div className="text-block">
                <h2>{projectTexts.meumaterial.title}</h2>
                <p>
                    {projectTexts.meumaterial.description}
                </p>
            </div>
       
            <div className="text-block">
                <h2>{projectTexts.homecam.title}</h2>
                <p>
                    {projectTexts.homecam.description}
                </p>
            </div>
            <div className="text-block">
                <h2>{projectTexts.franquiasistem.title}</h2>
                <p>
                    {projectTexts.franquiasistem.description}
                </p>
            </div>
            <ResumeDownload />
        </div>
    );
};

const styles: StyleSheetCSS = {
    video: {
        width: '100%',
        padding: 12,
    },
    caption: {
        width: '80%',
    },
};

export default SoftwareProjects;
